import { useAuthSetup } from "@/hooks/useAuthSetup";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Loader2 } from "lucide-react";

function HomePage() {
  const { isAuthenticated, isLoading: authLoading } = useAuthSetup();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading) {
      if (isAuthenticated) {
        navigate({ to: "/dashboard" });
      } else {
        navigate({ to: "/auth/sign-in" });
      }
    }
  }, [isAuthenticated, authLoading, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">Cargando...</p>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_home/")({
  component: HomePage,
});
